/////////////////////////////////////////////
// 無料お試し期間関連定数

import { addMonthLimitLastDays, calcLastDate } from './date_util';

/////////////////////////////////////////////
export const TRIAL_PERIOD_MONTH = 1;   // 無料お試し期間（ヶ月）

/////////////////////////////////////////////
// 無料お試し期間ユーティリティ
/////////////////////////////////////////////

/**
 * 無料お試し期間終了日の算出。
 * @param startDate 登録開始日。
 * @param addDate お試し期間終了日に加算する日数。
 * @returns お試し期間終了日 + addDate
 */
export function calcTrialEndDate( startDate: Date, addDate: number) {
  // x月1日の場合はx月末日まで。それ以外は翌月末までとする。（TRIAL_PERIOD_MONTHが1の場合）
  let endDate = new Date( startDate );  // copy
  endDate = addMonthLimitLastDays( endDate, TRIAL_PERIOD_MONTH ); // TRIAL_PERIOD_MONTH ヶ月加算。
  endDate.setDate( endDate.getDate() - 1 ); // x月1日にTヶ月加算すると、x+T月1日になってしまうので、-1日して、末日までとする。

  // 末日にする。
  endDate = calcLastDate( endDate );

  // 日付加算
  endDate.setDate(endDate.getDate() + addDate);

  return endDate;
}

/**
 * 無料お試し期間終了日文字列の作成。
 * @param startDateStr 開始日文字列
 * @returns
 */
export function makeTrialEndDateStr( startDateStr: string) {
  const startDate = new Date(startDateStr);
  const endDate = calcTrialEndDate( startDate, 0 );

  // 文字列化
  return '' + (endDate.getMonth() + 1) + '/' + endDate.getDate();
}
